import {
  FAILURE_CREATE_SURVEY,
  FAILURE_DELETE_SURVEY,
  FAILURE_FETCH_SURVEYS,
  FAILURE_FETCH_SURVEY_RESULT_CATEGORY_DETAIL,
  FAILURE_FETCH_SURVEY_RESULT_CATEGORY_SUMMARY,
  FAILURE_FETCH_SURVEY_RESULT_RATIO_DEPARTMENTS,
  FAILURE_FETCH_SURVEY_RESULT_RATIO_DISTRIBUTION,
  FAILURE_FETCH_SURVEY_RESULT_RATIO_ENGAGEMENTS,
  FAILURE_FETCH_SURVEY_RESULT_RATIO_SUMMARY,
  FAILURE_FETCH_SURVEY_RESULT_RATIO_TIME_SERIES,
  FAILURE_UPDATE_SURVEY,
  REQUEST_CREATE_SURVEY,
  REQUEST_DELETE_SURVEY,
  REQUEST_FETCH_SURVEYS,
  REQUEST_FETCH_SURVEY_RESULT_CATEGORY_DETAIL,
  REQUEST_FETCH_SURVEY_RESULT_CATEGORY_SUMMARY,
  REQUEST_FETCH_SURVEY_RESULT_RATIO_DEPARTMENTS,
  REQUEST_FETCH_SURVEY_RESULT_RATIO_DISTRIBUTION,
  REQUEST_FETCH_SURVEY_RESULT_RATIO_ENGAGEMENTS,
  REQUEST_FETCH_SURVEY_RESULT_RATIO_SUMMARY,
  REQUEST_FETCH_SURVEY_RESULT_RATIO_TIME_SERIES,
  REQUEST_UPDATE_SURVEY,
  RESET_SURVEY_ID,
  RESET_SURVEY_STATE,
  SET_SURVEY_ID,
  SUCCESS_CREATE_SURVEY,
  SUCCESS_DELETE_SURVEY,
  SUCCESS_FETCH_SURVEYS,
  SUCCESS_FETCH_SURVEY_RESULT_CATEGORY_DETAIL,
  SUCCESS_FETCH_SURVEY_RESULT_CATEGORY_SUMMARY,
  SUCCESS_FETCH_SURVEY_RESULT_RATIO_DEPARTMENTS,
  SUCCESS_FETCH_SURVEY_RESULT_RATIO_DISTRIBUTION,
  SUCCESS_FETCH_SURVEY_RESULT_RATIO_ENGAGEMENTS,
  SUCCESS_FETCH_SURVEY_RESULT_RATIO_SUMMARY,
  SUCCESS_FETCH_SURVEY_RESULT_RATIO_TIME_SERIES,
  SUCCESS_UPDATE_SURVEY,
} from 'actions/actionTypes';
import {
  CategoryDetailTypes,
  QuestionCategoryTypes,
  ResultCategorySummaryTypes,
  ResultRatioDepartmentsTypes,
  ResultRatioDistributionTypes,
  ResultRatioEngagementsTypes,
  ResultRatioSummaryTypes,
  ResultRatioTimeSeriesTypes,
  SurveyIdTypes,
  SurveyInputTypes,
  SurveyTypes,
} from 'types/backend/engagementSurvey/result';

export const resetSurveyState = () => ({
  type: RESET_SURVEY_STATE,
});

export const requestFetchSurveys = () => ({
  type: REQUEST_FETCH_SURVEYS,
});

export const successFetchSurveys = (payload: SurveyTypes) => ({
  type: SUCCESS_FETCH_SURVEYS,
  payload,
});

export const failureFetchSurveys = () => ({
  type: FAILURE_FETCH_SURVEYS,
});

export const requestCreateSurvey = (params: SurveyInputTypes) => ({
  type: REQUEST_CREATE_SURVEY,
  params,
});

export const successCreateSurvey = (payload: SurveyTypes) => ({
  type: SUCCESS_CREATE_SURVEY,
  payload,
});

export const failureCreateSurvey = () => ({
  type: FAILURE_CREATE_SURVEY,
});

export const requestUpdateSurvey = (params: SurveyInputTypes) => ({
  type: REQUEST_UPDATE_SURVEY,
  params,
});

export const successUpdateSurvey = (payload: SurveyTypes) => ({
  type: SUCCESS_UPDATE_SURVEY,
  payload,
});

export const failureUpdateSurvey = () => ({
  type: FAILURE_UPDATE_SURVEY,
});

export const requestDeleteSurvey = (id: string) => ({
  type: REQUEST_DELETE_SURVEY,
  id,
});

export const successDeleteSurvey = (id: string) => ({
  type: SUCCESS_DELETE_SURVEY,
  id,
});

export const failureDeleteSurvey = () => ({
  type: FAILURE_DELETE_SURVEY,
});

export const setSurveyId = (id: string) => ({
  type: SET_SURVEY_ID,
  id,
});

export const resetSurveyId = () => ({
  type: RESET_SURVEY_ID,
});

export const requestFetchSurveyResultRatioSummary = (surveyId: SurveyIdTypes) => ({
  type: REQUEST_FETCH_SURVEY_RESULT_RATIO_SUMMARY,
  surveyId,
});

export const successFetchSurveyResultRatioSummary = (payload: ResultRatioSummaryTypes) => ({
  type: SUCCESS_FETCH_SURVEY_RESULT_RATIO_SUMMARY,
  payload,
});

export const failureFetchSurveyResultRatioSummary = () => ({
  type: FAILURE_FETCH_SURVEY_RESULT_RATIO_SUMMARY,
});

export const requestFetchSurveyResultRatioDistribution = (surveyId: SurveyIdTypes) => ({
  type: REQUEST_FETCH_SURVEY_RESULT_RATIO_DISTRIBUTION,
  surveyId,
});

export const successFetchSurveyResultRatioDistribution = (
  payload: ResultRatioDistributionTypes,
) => ({
  type: SUCCESS_FETCH_SURVEY_RESULT_RATIO_DISTRIBUTION,
  payload,
});

export const failureFetchSurveyResultRatioDistribution = () => ({
  type: FAILURE_FETCH_SURVEY_RESULT_RATIO_DISTRIBUTION,
});

export const requestFetchSurveyResultRatioEngagements = (surveyId: SurveyIdTypes) => ({
  type: REQUEST_FETCH_SURVEY_RESULT_RATIO_ENGAGEMENTS,
  surveyId,
});

export const successFetchSurveyResultRatioEngagements = (payload: ResultRatioEngagementsTypes) => ({
  type: SUCCESS_FETCH_SURVEY_RESULT_RATIO_ENGAGEMENTS,
  payload,
});

export const failureFetchSurveyResultRatioEngagements = () => ({
  type: FAILURE_FETCH_SURVEY_RESULT_RATIO_ENGAGEMENTS,
});

export const requestFetchSurveyResultRatioTimeSeries = (surveyId: SurveyIdTypes) => ({
  type: REQUEST_FETCH_SURVEY_RESULT_RATIO_TIME_SERIES,
  surveyId,
});

export const successFetchSurveyResultRatioTimeSeries = (payload: ResultRatioTimeSeriesTypes[]) => ({
  type: SUCCESS_FETCH_SURVEY_RESULT_RATIO_TIME_SERIES,
  payload,
});

export const failureFetchSurveyResultRatioTimeSeries = () => ({
  type: FAILURE_FETCH_SURVEY_RESULT_RATIO_TIME_SERIES,
});

export const requestFetchSurveyResultRatioDepartments = (
  surveyId: SurveyIdTypes,
  parentId: number | null,
) => ({
  type: REQUEST_FETCH_SURVEY_RESULT_RATIO_DEPARTMENTS,
  surveyId,
  parentId,
});

export const successFetchSurveyResultRatioDepartments = (payload: ResultRatioDepartmentsTypes) => ({
  type: SUCCESS_FETCH_SURVEY_RESULT_RATIO_DEPARTMENTS,
  payload,
});

export const failureFetchSurveyResultRatioDepartments = () => ({
  type: FAILURE_FETCH_SURVEY_RESULT_RATIO_DEPARTMENTS,
});

export const requestFetchSurveyResultCategorySummary = (surveyId: SurveyIdTypes) => ({
  type: REQUEST_FETCH_SURVEY_RESULT_CATEGORY_SUMMARY,
  surveyId,
});

export const successFetchSurveyResultCategorySummary = (payload: ResultCategorySummaryTypes) => ({
  type: SUCCESS_FETCH_SURVEY_RESULT_CATEGORY_SUMMARY,
  payload,
});

export const failureFetchSurveyResultCategorySummary = () => ({
  type: FAILURE_FETCH_SURVEY_RESULT_CATEGORY_SUMMARY,
});

export const requestFetchSurveyResultCategoryDetail = (
  categoryType: QuestionCategoryTypes,
  surveyId: SurveyIdTypes,
) => ({
  type: REQUEST_FETCH_SURVEY_RESULT_CATEGORY_DETAIL,
  categoryType,
  surveyId,
});

export const successFetchSurveyResultCategoryDetail = (
  categoryType: QuestionCategoryTypes,
  payload: CategoryDetailTypes,
) => ({
  type: SUCCESS_FETCH_SURVEY_RESULT_CATEGORY_DETAIL,
  categoryType,
  payload,
});

export const failureFetchSurveyResultCategoryDetail = (categoryType: QuestionCategoryTypes) => ({
  type: FAILURE_FETCH_SURVEY_RESULT_CATEGORY_DETAIL,
  categoryType,
});
